import { render, staticRenderFns } from "./IotModelPointsGroupMenberForm.vue?vue&type=template&id=4ec35720&"
import script from "./IotModelPointsGroupMenberForm.vue?vue&type=script&lang=js&"
export * from "./IotModelPointsGroupMenberForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports